import Common from '../../../Common';
import { Flow } from './Flow';
import { FlowItem } from './flow/Item';

export type CompanyPbxDadDestination = FlowItem & { flow: Flow } | []

const Destination = class extends Common {
	inUse = (companyId: id, destinationId: id): CustomResponse<CompanyPbxDadDestination> =>
		this.get(`/company/${companyId}/pbxdad/destination/${destinationId}/inuse`)
}

export default Destination
